import { apiSlice } from "../../api-slice";
import { GetProposalParams } from "../proposal/proposal-api-request";
import { GetProposalResponse, ProposalListResponse } from "../proposal/proposal-api-state";
import { ProposalExtensionDefaultResponse } from "./proposal-extension-api-state";

export const proposalExtensionAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllRequestExtension: builder.query<ProposalListResponse, undefined | GetProposalParams>({
            query: (params) => ({
                url: `/api/financial-insurance/extension-requests`,
                params: params ?? {},
            }),
            transformResponse: (response: GetProposalResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
            providesTags: [
                { type: 'Proposal', id: 'LIST' },
                { type: 'ProposalExtension', id: 'LIST' },
            ],
        }),
        requestProposalExtension: builder.mutation<ProposalExtensionDefaultResponse, number>({
            query: (proposalId) => ({
                url: `/api/financial-insurance/${proposalId}/request-extension`,
                method: 'PUT',
            }),
            invalidatesTags: (_result, _error, clientId ) => [
                { type: 'ProposalExtension', id: clientId },
                { type: 'ProposalExtension', id: 'LIST' },
                { type: 'Proposal', id: 'LIST' },
            ],
        }),
        approvedProposalExtension: builder.mutation<ProposalExtensionDefaultResponse, number>({
            query: (proposalId) => ({
                url: `/api/financial-insurance/${proposalId}/approved-extension`,
                method: 'PUT',
            }),
            invalidatesTags: (_result, _error, clientId ) => [
                { type: 'ProposalExtension', id: clientId },
                { type: 'ProposalExtension', id: 'LIST' },
                { type: 'Proposal', id: 'LIST' },
            ],
        }),
        declinedProposalExtension: builder.mutation<ProposalExtensionDefaultResponse, number>({
            query: (proposalId) => ({
                url: `/api/financial-insurance/${proposalId}/declined-extension`,
                method: 'PUT',
            }),
            invalidatesTags: (_result, _error, clientId ) => [
                { type: 'ProposalExtension', id: clientId },
                { type: 'ProposalExtension', id: 'LIST' },
                { type: 'Proposal', id: 'LIST' },
            ],
        }),
    })
})

export const {
    useGetAllRequestExtensionQuery,
    useRequestProposalExtensionMutation,
    useApprovedProposalExtensionMutation,
    useDeclinedProposalExtensionMutation,
} = proposalExtensionAPI